class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
      searchInput: this.querySelector("input[data-search]"),
      listItems: this.querySelectorAll(".dropdown__list__item"),
      popularCountries: this.querySelector("[data-popular-countries]"),
      allCountries: this.querySelector("[data-all-countries]"),
    };

    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    if (this.elements.searchInput) {
      this.elements.searchInput.addEventListener(
        "input",
        this.filterCountries.bind(this)
      );
      this.elements.searchInput.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") {
          this.hidePanel();
          this.elements.button.focus();
        }
      });
    }

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );

    this.onHideDropdown = this.closeSelector.bind(this);
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
    document.body.removeEventListener("click", this.onHideDropdown);

    if (this.elements.searchInput) {
      this.elements.searchInput.value = "";
      this.filterCountries();
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
    this.elements.panel.toggleAttribute("hidden");

    if (!this.elements.panel.hasAttribute("hidden")) {
      document.body.addEventListener("click", this.onHideDropdown);
      if (this.elements.searchInput) {
        this.elements.searchInput.focus();
      }
    } else {
      document.body.removeEventListener("click", this.onHideDropdown);
    }
  }

  closeSelector(event) {
    const isClickInside = this.contains(event.target);
    if (!isClickInside) {
      this.hidePanel();
    }
  }

  filterCountries() {
    if (!this.elements.searchInput) return;

    const searchValue = this.elements.searchInput.value.toLowerCase().trim();
    const hasSearchValue = searchValue.length > 0;

    this.elements.listItems.forEach((item) => {
      const countryName = item.textContent.toLowerCase();
      const isVisible = countryName.includes(searchValue);
      item.style.display = isVisible ? "flex" : "none";
    });

    // Handle popular countries section visibility
    if (this.elements.popularCountries && this.elements.allCountries) {
      const hasVisiblePopularCountries = Array.from(
        this.elements.popularCountries.querySelectorAll(".dropdown__list__item")
      ).some((item) => item.style.display !== "none");

      this.elements.popularCountries.style.display =
        !hasVisiblePopularCountries || !hasSearchValue ? "none" : "flex";

      const label = this.elements.allCountries.querySelector(
        ".localization-selector__list-label"
      );
      if (label) {
        label.style.display = hasSearchValue ? "none" : "flex";
      }
    }
  }
}

customElements.define("localization-form", LocalizationForm);
